import { Type } from "@sinclair/typebox";
export const opaqueIdSchema = Type.String({ format: "uuid" });
export const isoTimestampSchema = Type.String({ format: "date-time" });
export const moneySchema = Type.Object({
    amount: Type.String({ pattern: "^-?(0|[1-9][0-9]*)(\\.[0-9]{1,4})?$" }),
    currency: Type.String({ pattern: "^[A-Z]{3}$" })
}, { $id: "Money", additionalProperties: false });
export const provenanceSchema = Type.Object({
    sourceKind: Type.String({ minLength: 1, maxLength: 80 }),
    sourceId: Type.Optional(Type.String({ minLength: 1, maxLength: 200 })),
    observedAt: Type.Optional(isoTimestampSchema),
    acquiredAt: isoTimestampSchema,
    qualityLabel: Type.Union([
        Type.Literal("alta"),
        Type.Literal("media"),
        Type.Literal("bassa"),
        Type.Literal("non_valutata")
    ]),
    verificationState: Type.Union([
        Type.Literal("fonte"),
        Type.Literal("derivata"),
        Type.Literal("verificata_operatore"),
        Type.Literal("in_conflitto")
    ]),
    limitationNote: Type.Optional(Type.String({ maxLength: 500 }))
}, { $id: "Provenance", additionalProperties: false });
export const problemSchema = Type.Object({
    type: Type.String({ format: "uri-reference" }),
    title: Type.String(),
    status: Type.Integer({ minimum: 400, maximum: 599 }),
    detail: Type.Optional(Type.String()),
    instance: Type.Optional(Type.String({ format: "uri-reference" }))
}, { $id: "Problem", additionalProperties: false });
//# sourceMappingURL=common.js.map